module.exports = new __parcel__URL__("https.170d6fe9.svg").toString();